import { Luggage, Plane, Wallet, type LucideIcon } from "lucide-react";

/**
 * One icon per product everywhere — product cards, the hub and the welcome tour (client review,
 * 22 Oct 2026): Wallet Libre a wallet, Apartado a suitcase, Viaja ahora · paga después a plane.
 * The keys are what admins pick in Productos (`products.icon`); the original seed keys still
 * resolve to the same icons so a database not yet migrated (037) looks the same.
 */
export const PRODUCT_ICONS: Record<string, LucideIcon> = {
  wallet: Wallet, luggage: Luggage, plane: Plane,
  "piggy-bank": Wallet, "map-pin": Luggage, "plane-takeoff": Plane
};
export const PRODUCT_ICON_CHOICES = ["wallet", "luggage", "plane"] as const;
export const productIcon = (key: string): LucideIcon => PRODUCT_ICONS[key] ?? Wallet;
